import React, { useState, useEffect, useReducer } from 'react';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Formik, Field } from 'formik';
import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';
import { Badge, Button } from 'react-bootstrap';
import Numeric from '../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import StockItems, { ITEMS_URL } from './StockItems';
import SelectProduct from '../../../../../components/SelectProduct';
import css from './style.module.css';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        id: action.payload.id,
        icon: action.payload.icon,
        productCode: action.payload.productCode,
        name: action.payload.name,
        productPrice: parseFloat(action.payload.productPrice),
        productCost: parseFloat(action.payload.productCost),
        productCount: action.payload.productCount,
        productWeight: action.payload.productWeight,
        qty: action.payload.qty,
        cost: action.payload.cost
          ? parseFloat(action.payload.cost)
          : parseFloat('0'),
        note: action.payload.note,
        items: [],
      };
    case 'setProduct':
      return {
        ...state,
        productCode: action.payload.productCode,
        name: action.payload.name,
        productPrice: action.payload.price,
        icon: action.payload.icon,
        subProduct: action.payload.subProduct,
      };
    case 'setProductCode':
      return { ...state, productCode: action.payload };
    case 'setQty':
      return { ...state, qty: Number(action.payload) };
    case 'setNote':
      return { ...state, note: action.payload };
    case 'setItems':
      return {
        ...state,
        items: action.payload,
      };
    default:
      console.log('Wrong Dispatch: ', action);
  }
}

const StockCreateForm = (props) => {
  const {
    intl,
    actionsLoading,
    info,
    error,
    stockForView,
    initialStock,
    btnRefSave,
    newClick,
    btnRefNew,
    saveStock,
    onHide,
    goToView,
  } = props;
  // States
  const [state, dispatch] = useReducer(reducer, initialStock);
  const [err, setErr] = useState();
  const [msg, setMsg] = useState();
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(actionsLoading);
  const [openSelectProducts, setOpenSelectProducts] = useState(false);

  // Messages
  const REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const StockCreateSchema = Yup.object().shape({
    productCode: Yup.string().required(REQUIRED),
    qty: Yup.string().required(REQUIRED),
  });

  useEffect(() => {
    //console.log('StockForView', stockForView);
    dispatch({ type: 'init', payload: initialStock });
  }, []);

  useEffect(() => {
    setMsg('');
    setErr(error);
  }, [error]);
  useEffect(() => {
    setErr('');
    setMsg(info);
  }, [info]);
  useEffect(() => {
    setLoading(actionsLoading);
  }, [actionsLoading]);
  useEffect(() => {
    //console.log('StockCreateForm.STATE', state);
  }, [state]);

  const save = (values) => {
    //console.log('Save:', values);
    saveItems();
  };
  const saveItems = () => {
    setLoading(true);
    axios
      .post(
        ITEMS_URL,
        {
          productCode: state.productCode,
          newQty: state.qty,
          items: state.items,
          note: state.note,
        },
        { headers: { action: 'post' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
            setErr('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            break;
          case 'SUCCESS_WITH_INFO':
            setErr('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            goToView(response.data.data);
            break;
          case 'SUCCESS_WITH_WARNING':
            //console.log('set items: ', response.data.data);
            setErr('');
            setMsg(response.data.data);
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setErr(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setErr(error);
        setLoading(false);
      });
  };

  const onClick = () => {
    setOpenSelectProducts(true);
  };

  const setProductCode = (productCode) => {
    dispatch({ type: 'setProductCode', payload: productCode });
  };

  const setQty = (qty) => {
    dispatch({ type: 'setQty', payload: qty });
  };

  const setNote = (note) => {
    dispatch({ type: 'setNote', payload: note });
  };

  const getPic = (productCode, pic) => {
    if (pic)
      return `${baseUrl}/product-image-download?id=${productCode}&file=${pic}`;
    else return toAbsoluteUrl('/media/logos/logo-gc.png');
  };

  const addSelectedItems = (selectedProduct) => {
    console.log('SelectedProduct', selectedProduct);
    if (selectedProduct && selectedProduct.length > 0)
      dispatch({ type: 'setProduct', payload: selectedProduct[0] });
  };

  const changeItems = (items) => {
    dispatch({ type: 'setItems', payload: items });
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={StockCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              {openSelectProducts && (
                <SelectProduct
                  openSelectProducts={openSelectProducts}
                  setOpenSelectProducts={setOpenSelectProducts}
                  addSelectedItems={addSelectedItems}
                  //existingItems={entities}
                  existingItems={[state.productCode]}
                  multiSelect={false}
                />
              )}
              <div className='form-group row'>
                <div className='col-2'>
                  <div className=''>
                    <div className={css.row}>
                      <div
                        style={{
                          border: '3',
                          width: '100%',
                          height: 'auto',
                          borderRadius: '5%',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          className='img-thumbnail'
                          style={{ width: '100%', height: '100%' }}
                          src={getPic(state.productCode, state.icon)}
                        ></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-10'>
                  <div className='form-group row'>
                    <div className='col-5'>
                      <Field
                        name='productCode'
                        className='form-control form-control-sm'
                        onBlur={(e) => {
                          setProductCode(e.target.value);
                        }}
                        placeholder='Бүтээгдэхүүн код'
                        disabled={state.id}
                      />
                      {errors.productCode && touched.productCode ? (
                        <div>{errors.productCode}</div>
                      ) : null}
                    </div>
                    <div className='col-1'>
                      <Button onClick={onClick}>..</Button>
                    </div>
                    <div className='col-6'>
                      {state.subProduct > 0 ? (
                        <h4>
                          <Badge variant='secondary'>
                            Багц бүтээгдэхүүн тул дэд бараа агуулна!
                          </Badge>
                        </h4>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-6'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.PRODUCTNAME' />
                      </label>
                      <Field
                        name='name'
                        className='form-control form-control-sm'
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.PRICE' />
                      </label>
                      <Numeric
                        id='productPrice'
                        name='productPrice'
                        value={state.productPrice}
                        className='form-control form-control-sm'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.DETAIL.QTY' />
                      </label>
                      <Numeric
                        name='qty'
                        value={state.qty}
                        onChange={setQty}
                        className='form-control form-control-sm'
                        negative={false}
                        type='number'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={state.id}
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <Field
                        name='note'
                        className='form-control form-control-sm'
                        as='textarea'
                        placeholder='Тэмдэглэл'
                        rows='3'
                        onBlur={(e) => {
                          setNote(e.target.value);
                        }}
                        disabled={state.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                onClick={onHide}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
      {state.productCode && (
        <StockItems
          productCode={state.productCode}
          newQty={state.qty}
          changeItems={changeItems}
        />
      )}
    </>
  );
};

export default injectIntl(StockCreateForm);
